var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 5H30.0001C30.8841 5 31.732 5.35119 32.3571 5.97631C32.9822 6.60143 33.3334 7.44928 33.3334 8.33333V31.6667C33.3334 32.5507 32.9822 33.3986 32.3571 34.0237C31.732 34.6488 30.8841 35 30.0001 35H10.0001C9.11603 35 8.26818 34.6488 7.64306 34.0237C7.01794 33.3986 6.66675 32.5507 6.66675 31.6667V8.33333C6.66675 7.44928 7.01794 6.60143 7.64306 5.97631C8.26818 5.35119 9.11603 5 10.0001 5H13.3334",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 19.1667L18.94 21.4399C19.0627 21.5626 19.2636 21.5559 19.3779 21.4253L25.0001 15",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 1.6665H14.9999C14.0794 1.6665 13.3333 2.4127 13.3333 3.33317V6.6665C13.3333 7.58698 14.0794 8.33317 14.9999 8.33317H24.9999C25.9204 8.33317 26.6666 7.58698 26.6666 6.6665V3.33317C26.6666 2.4127 25.9204 1.6665 24.9999 1.6665Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControls);
export default __webpack_public_path__ + "static/media/controls.f1737a0e7ae26e41fada312400595b21.svg";
export { ForwardRef as ReactComponent };